import ArraySnippetInterface from 'components/organisms/late-swap/services/array-snippet-interface';
import ArraySnippet from 'components/organisms/late-swap/services/array-snippet';
import {validationCriteriaStructure, SnippetValidatorInterface} from './interfaces';
import {SnippetValidator} from './validators';
import SnippetIsInvalidError from './snippet-is-invalid-error';
import {playersValidationCriteriaMap} from 'components/organisms/late-swap/services/maps';

const PlayersSnippetValidatorFactory = {
    getValidator(sportConfig): SnippetValidatorInterface {
        const site = sportConfig.getSite().toLowerCase();
        const sport = sportConfig.getSport().toLowerCase();

        try {
            const validationCriteria = playersValidationCriteriaMap[site][sport];

            return new SnippetValidator(validationCriteria);
        } catch (e) {
            if (e instanceof TypeError) {
                throw new SnippetIsInvalidError('Validator is undefined.');
            }
            throw e;
        }
    },
};

export default PlayersSnippetValidatorFactory;
